import CheckmateSelect from '../CheckmateSelect';
import { IMultiSelectOption } from '../../../interfaces/ILookup';
import { IQueryFilterCriteriaSelectionValue } from '../../../interfaces/IQuery';
import { useGetUsStatesLookup } from '../../../shared/react-query-hooks/useUsStatesLookup';
import { useMemo } from 'react';

export interface IUsStateSelectorProps {
    disabled?: boolean;
    multi?: boolean;
    onChange: (optionsList: any) => void;
    value: IQueryFilterCriteriaSelectionValue[] | undefined;
    validationError?: string | undefined;
}

export function UsStateSelector(props: IUsStateSelectorProps) {
    const { data, isLoading } = useGetUsStatesLookup();

    const availableOptions = useMemo(
        () =>
            data?.map(
                (usState) =>
                    ({
                        label: usState.name,
                        value: usState.name,
                        id: usState.id!,
                    } as IMultiSelectOption)
            ),
        [props.value, data]
    );

    const selectedOptions = useMemo(
        () => availableOptions?.filter((opt) => props.value?.map((v) => v.id).includes(opt.id)),
        [props.value, availableOptions]
    );

    return (
        <>
            <CheckmateSelect
                isMulti={props.multi}
                options={availableOptions ?? []}
                isDisabled={props.disabled}
                value={selectedOptions}
                onChange={props.onChange}
                isLoading={isLoading}
            />
            <span className="text-danger">{props.validationError}</span>
        </>
    );
}
